module.exports = __webpack_public_path__ + "static/media/facebook.7e8b925c.svg";